import { useContext } from 'react';

import { Pagination } from '@/shared/ui';

import { TattooSearchContext } from '../../context/TattooSearchContext';
import { PAGE_SIZE } from '../../context/TattooSearchProvider';

export const TattooSearchPagination: React.FC = () => {
  const { page, total, result, handlePageChange } = useContext(TattooSearchContext);

  const hasResults = Array.isArray(result) ? result.length > 0 : false;
  const hasAtLeastTwoPages = total > PAGE_SIZE;

  if (!hasResults || !hasAtLeastTwoPages) {
    return null;
  }

  return <Pagination current={page} total={total} onChange={handlePageChange} />;
};
